module.exports = __webpack_public_path__ + "static/media/2-en.7e582919.svg";